import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { formatDateTime } from "../helper/dateFormatter";
import { UserName } from "../components/UserName";

interface Props<T> {
  show: boolean;
  title: string;
  subTitle?: string;
  data: any;
  addComments: boolean;
  textProvider?: (iten: T) => string;
  timeProvider?: (iten: T) => Date;
  userIdProvider?: (iten: T) => string;
  onAddComment?: (comments: string) => Promise<void>;
  handleModal: () => void;
}

export const GenericCommentsModal = <T,>({
  show,
  title,
  subTitle,
  data,
  addComments,
  textProvider,
  timeProvider,
  userIdProvider,
  onAddComment,
  handleModal
}: Props<T>) => {
  const [comments, setComments] = useState<string>();
  const addComment = async () => {
    if (!comments) {
      return;
    }

    await onAddComment?.(comments);
    handleModal();
  }

  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          handleModal();
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3 className="fs-16">{subTitle}</h3>
          {data !== undefined && data.comments.comments.map((comment: any, index: number) => (
            <div key={index} className="border rounded mt-4">
              <div className="d-flex align-items-start px-3 py-2 fs-14">
                <div>
                  <span className="material-symbols-outlined fs-20 me-1 mt-1">
                    comment
                  </span>
                </div>
                <div className="flex-fill">{comment.comment}</div>
              </div>

              <div className="d-flex bg-gray-FAF justify-content-between fs-12 px-3 py-2">
                <div className="text-light">
                  {formatDateTime(comment.createdAt)}
                </div>
                <div className="d-flex align-items-center text-base">
                  <span className="material-symbols-outlined fs-18 me-1">
                    person
                  </span>
                  <span><UserName userId={comment.createdBy}></UserName></span>
                </div>
              </div>
            </div>
          ))}
        </Modal.Body>
        {
          addComments ?
            <Modal.Footer className="justify-content-between">
              <textarea className="form-field w-100" rows={2} onChange={event => setComments(event.target.value)}></textarea>
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary rounded-pill px-6 my-0"
                onClick={() => handleModal}
              >
                Discard
              </button>
              <button
                type="button"
                className="btn btn-sm btn-secondary rounded-pill px-6 my-0"
                onClick={addComment}
              >
                Submit
              </button>
            </Modal.Footer> : ''
        }
      </Modal>
    </>
  );
};
